import { useQuery } from 'react-query';
import {
	getMisbilledHCPCS,
	getMisbilledHCPCSProducts,
	getMisbilledUnits,
	getMisbilledUnitsProducts,
	getUnmatchedClaimsToInvoices,
	getUnmatchedInvoicesToClaims,
	getUnmatchedInvoicesToClaimsProducts,
} from '@/services/billingTools';
import type { FilterType } from '@/types/table';

export const useGetMisbilledHCPCS = ({
	page = 1,
	limit = 15,
	enabled = true,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	dateRangeFilter = '',
}: FilterType) => {
	return useQuery({
		queryKey: [
			'MisbilledHCPCS',
			page,
			limit,
			columnsFilters,
			search,
			globalFilters,
			sort,
			dateRangeFilter,
		],
		queryFn: () =>
			getMisbilledHCPCS(
				page,
				limit,
				columnsFilters,
				search,
				globalFilters as string,
				sort as string,
				dateRangeFilter,
			),
		enabled, // Replace 'true' with the appropriate condition if needed
		keepPreviousData: false, // Keep showing previous data while fetching new data
		// staleTime: 30000, // Consider data fresh for 30 seconds
	});
};

export const useGetMisbilledUnits = ({
	page = 1,
	limit = 15,
	enabled = true,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	dateRangeFilter = '',
}: FilterType) => {
	return useQuery({
		queryKey: [
			'MisbilledUnits',
			page,
			limit,
			columnsFilters,
			search,
			globalFilters,
			sort,
			dateRangeFilter,
		],
		queryFn: () =>
			getMisbilledUnits(
				page,
				limit,
				columnsFilters,
				search,
				globalFilters as string,
				sort as string,
				dateRangeFilter,
			),
		enabled, // Replace 'true' with the appropriate condition if needed
		keepPreviousData: false, // Keep showing previous data while fetching new data
		// staleTime: 30000, // Consider data fresh for 30 seconds
	});
};

export const useGetUnmatchedClaimstoinvoices = ({
	page = 1,
	limit = 15,
	enabled = true,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	dateRangeFilter = '',
}: FilterType) => {
	return useQuery({
		queryKey: [
			'UnmatchedClaimstoinvoices',
			page,
			limit,
			columnsFilters,
			search,
			globalFilters,
			sort,
			dateRangeFilter,
		],
		queryFn: () =>
			getUnmatchedClaimsToInvoices(
				page,
				limit,
				columnsFilters,
				search,
				globalFilters as string,
				sort as string,
				dateRangeFilter,
			),
		enabled, // Replace 'true' with the appropriate condition if needed
		keepPreviousData: false, // Keep showing previous data while fetching new data
		// staleTime: 30000, // Consider data fresh for 30 seconds
	});
};

export const useGetUnmatchedInvoicesToClaims = ({
	page = 1,
	limit = 15,
	enabled = true,
	columnsFilters = '[]',
	search = '',
	globalFilters = '[]',
	sort = '',
	dateRangeFilter = '',
}: FilterType) => {
	return useQuery({
		queryKey: [
			'UnmatchedInvoicesToClaims',
			page,
			limit,
			columnsFilters,
			search,
			globalFilters,
			sort,
			dateRangeFilter,
		],
		queryFn: () =>
			getUnmatchedInvoicesToClaims(
				page,
				limit,
				columnsFilters,
				search,
				globalFilters as string,
				sort as string,
				dateRangeFilter,
			),
		enabled, // Replace 'true' with the appropriate condition if needed
		keepPreviousData: false, // Keep showing previous data while fetching new data
		// staleTime: 30000, // Consider data fresh for 30 seconds
	});
};

export const useGetMisbilledHCPCSProducts = ({
	globalFilters = '[]',
	enabled = true,
}: FilterType) => {
	return useQuery({
		queryKey: ['MisbilledHCPCSProducts', globalFilters],
		queryFn: () => getMisbilledHCPCSProducts(globalFilters as string),
		enabled, // Replace 'true' with the appropriate condition if needed
		keepPreviousData: false, // Keep showing previous data while fetching new data
		// staleTime: 30000, // Consider data fresh for 30 seconds
	});
};

export const useGetMisbilledUnitsProducts = ({
	enabled = true,
	globalFilters = '[]',
}: FilterType) => {
	return useQuery({
		queryKey: ['MisbilledUnitsProducts', globalFilters],
		queryFn: () => getMisbilledUnitsProducts(globalFilters as string),
		enabled, // Replace 'true' with the appropriate condition if needed
		keepPreviousData: false, // Keep showing previous data while fetching new data
		// staleTime: 30000, // Consider data fresh for 30 seconds
	});
};

export const useGetUnmatchedInvoicesToClaimsProducts = ({
	enabled = true,
	globalFilters = '[]',
}: FilterType) => {
	return useQuery({
		queryKey: ['UnmatchedInvoicesToClaimsProducts', globalFilters],
		queryFn: () =>
			getUnmatchedInvoicesToClaimsProducts(globalFilters as string),
		enabled, // Replace 'true' with the appropriate condition if needed
		keepPreviousData: false, // Keep showing previous data while fetching new data
		// staleTime: 30000, // Consider data fresh for 30 seconds
	});
};
